import cx from 'clsx';
import { Text } from '@paylink/constants';
import {
	InputCard,
	PaymentInfo,
	Footer,
	Header,
	TerminalState,
} from '@paylink/components/composed';
import { PaylinkState } from '@paylink/types';

import { Button, HelperText } from '@shared/components/core';

import styles from './MobileLayout.module.scss';
import { IMobileLayoutProps } from './MobileLayout.types';

const MobileLayout = ({
	merchantName,
	logoId,
	amount,
	description,
	subscriptionDetails,
	orderId,
	expireAt,
	phone,
	phoneError,
	phoneNumberRequired,
	isPaylinkVerifying,
	paylinkState,
	handlePhoneInput,
	handleVerifyPhone,
	handleProceed,
	handleKeyDown,
}: IMobileLayoutProps) => {
	const isActiveState =
		paylinkState === PaylinkState.CREATED ||
		paylinkState === PaylinkState.ACTIVE;

	if (!isActiveState) {
		return (
			<div className={cx(styles.pageWrapper, 'bg-tertiary d-flex flex-column')}>
				<div className="bg-white">
					<Header
						logoId={logoId}
						merchantName={merchantName}
						isMobile
						className="pl6 pr2"
					/>
				</div>
				<div className="flex1 p4">
					<TerminalState
						paylinkState={paylinkState}
						merchantName={merchantName}
						amount={amount}
						orderId={orderId}
						expireAt={expireAt}
						description={description}
						isMobile
					/>
				</div>

				<div className={styles.footer}>
					<Footer isMobile />
				</div>
			</div>
		);
	}

	return (
		<div className={cx(styles.pageWrapper, 'bg-tertiary d-flex flex-column')}>
			<div className={cx('relative flex1')}>
				<div className={cx('px4 py3', styles.width100vw)}>
					<PaymentInfo
						merchantName={merchantName}
						logoId={logoId}
						amount={amount}
						description={description}
						subscriptionDetails={subscriptionDetails}
						isMobile
					/>
				</div>

				<div className={cx('absolute bottom0 left0', styles.width100vw)}>
					{phoneNumberRequired ? (
						<InputCard
							title={Text.VERIFY_PHONE_NUMBER}
							subtitle={Text.VERIFY_PHONE_SUBTITLE}
							phone={phone}
							isPaylinkVerifying={isPaylinkVerifying}
							phoneError={phoneError}
							handlePhoneInput={handlePhoneInput}
							handleVerifyPhone={handleVerifyPhone}
							handleKeyDown={handleKeyDown}
							cardClassName="border-grey2 p4 gap8"
							isMobile
						/>
					) : (
						<div
							className={cx(
								'bg-white card-shadow2 px4 pt4 d-flex flex-column gap3',
								styles.bottomCard,
							)}
						>
							<HelperText message={phoneError} label={Text.PROCEED} />
							<Button
								disabled={isPaylinkVerifying}
								variant="primary"
								onClick={handleProceed}
								className="width100 border-radius2 p4"
							>
								{Text.PROCEED}
							</Button>
						</div>
					)}
				</div>
			</div>

			{/* ── Branding footer ── */}
			<div className={styles.footer}>
				<Footer isMobile />
			</div>
		</div>
	);
};

export default MobileLayout;
